import moment from "moment";

export const nullableDateToMoment = (date, defaultValue = "2000-01-01") => date ? moment(date) : moment(defaultValue);

export const formatDate = (date, defaultValue = null, defaultFormat = "YYYY-MM-DD") => {
    // If both the given date and default value are null or empty return an empty string. Try to pass null or empty as a moment date results in the value 'invalid date'.
    if ((!date || date === "") && (!defaultValue || defaultValue === "")) {
        return "";
    }

    return nullableDateToMoment(date, defaultValue).format(defaultFormat);
};